import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskLines, Reveal, SectionLabel } from "./Motion";
import { scrollToId } from "@/lib/scroll";
import { useT } from "@/i18n";

const ROLES = ["Progettista strutturale", "Fornitore del legno", "Carpenteria metallica", "Impresa di montaggio", "Direzione di cantiere"];
const CHAIN = ["Progetto", "Produzione", "Carpenteria", "Trasporto", "Posa in opera"];

const Role = ({ r, i }) => (
  <motion.li initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.5 }} className="relative w-fit py-2" data-testid={`onestop-role-${i}`}>
    <span className="font-display text-2xl font-semibold text-[#A39E93] sm:text-4xl">{r}</span>
    <motion.span
      variants={{ hidden: { scaleX: 0 }, show: { scaleX: 1, transition: { duration: 0.7, delay: 0.3 + i * 0.15, ease: [0.76, 0, 0.24, 1] } } }}
      className="absolute left-0 right-0 top-1/2 h-[3px] origin-left bg-[#C26D38]"
    />
  </motion.li>
);

export const OneStop = () => {
  const t = useT();
  return (
  <section id="interlocutore" className="grain relative bg-[#121110] px-5 py-28 text-[#F7F5F0] sm:px-8 lg:py-40" data-testid="onestop-section">
    <div className="mx-auto max-w-[1500px]">
      <SectionLabel index="02" dark>{t("one.label", "Unico interlocutore")}</SectionLabel>
      <div className="mt-14 grid gap-16 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-5">
          <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-[#A39E93]">{t("one.instead", "Invece di cercare…")}</p>
          <ul>{ROLES.map((r, i) => <Role key={r} r={t(`one.role${i}`, r)} i={i} />)}</ul>
        </div>
        <div className="lg:col-span-7">
          <MaskLines
            className="font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-5xl lg:text-[4.2rem]"
            lines={[t("one.h1", "…ti rivolgi a"), <span key="u"><em className="font-serif font-normal text-[#D98A52]">{t("one.h2em", "una sola")}</em> {t("one.h2b", "azienda.")}</span>]}
          />
          <Reveal delay={0.2} className="mt-8 max-w-xl text-base leading-relaxed text-[#A39E93] sm:text-lg">
            {t("one.text2", "Dal progetto alla realizzazione, Emma Industrie è il tuo unico interlocutore tecnico ed energetico: un solo referente, un solo contratto, una sola responsabilità. Al tuo fianco un team di collaboratori storici con oltre 20 anni di esperienza, veri membri della famiglia Emma.")}
          </Reveal>
          <Reveal delay={0.3} className="mt-12">
            <ol className="flex flex-wrap items-center gap-2">
              {CHAIN.map((c, i) => (
                <li key={c} className="flex items-center gap-2">
                  <span className="rounded-full border border-[#F7F5F0]/20 px-4 py-2 font-mono text-xs uppercase tracking-[0.15em]">{t(`one.chain${i}`, c)}</span>
                  {i < CHAIN.length - 1 && <ArrowRight className="h-4 w-4 text-[#D98A52]" />}
                </li>
              ))}
            </ol>
          </Reveal>
          <Reveal delay={0.4}>
            <button onClick={() => scrollToId("#contatti")} className="btn-amber mt-12" data-testid="onestop-cta">{t("one.cta", "Parla con il tuo referente")} <ArrowRight className="h-4 w-4" /></button>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};
